import apiClient from "@/api/client";

export default {
  fetchTechnicians() {
    return apiClient.get("/technicians");
  },
};
